import React, { useEffect, useState } from "react";
import axios from "axios";
import "./DeliveryAddress.css";
import {baseURL} from "./api";

const DeliveryAddress = ({ vendorId, onAddressSelect }) => {
  const [addresses, setAddresses] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [editingIndex, setEditingIndex] = useState(null);
  const [isDeliveryConfirmed, setIsDeliveryConfirmed] = useState(false);
  const [editedAddress, setEditedAddress] = useState({
  pincode: "",
  flat: "",
  area: "",
  landmark: "",
});

  const [showAddForm, setShowAddForm] = useState(false);
  const [newAddress, setNewAddress] = useState({
  pincode: "",
  flat: "",
  area: "",
  landmark: ""
});


  useEffect(() => {
  const fetchAddresses = async () => {
    try {
      // First try to get saved addresses from DB
      const res = await axios.get(`${baseURL}/getVendorDeliveryAddresses/${vendorId}`);
      const savedAddresses = res.data;

      if (savedAddresses.length > 0) {
        // If saved addresses exist, use them
        const updated = savedAddresses.map((addr, index) => ({
          ...addr,
          isSelected: addr.isSelected || index === 0, // select the first one if none marked
        }));
        setAddresses(updated);
        setSelectedIndex(updated.findIndex((a) => a.isSelected) || 0);
      } else {
        // If no saved addresses, fallback to default vendor address
        const vendorRes = await axios.get(`${baseURL}/getVendor/${vendorId}`);
        const vendor = vendorRes.data;

        const defaultAddress = [
          {
            name: vendor.vendorName,
            address: vendor.vendorAddress || "No address available",
            phone: vendor.mobile || "No Phone Number",
            isSelected: true,
          },
        ];

        setAddresses(defaultAddress);
        setSelectedIndex(0);
      }
    } catch (err) {
      console.error("Failed to fetch addresses:", err);
    }
  };

  if (vendorId) {
    fetchAddresses();
  }
}, [vendorId]);



  const handleSelectAddress = (index) => {
  setSelectedIndex(index);
  setAddresses(addresses.map((addr, i) => ({
    ...addr,
    isSelected: i === index,
  })));
};


  const handleEditClick = (index) => {
  setEditingIndex(index);
  setEditedAddress({
    pincode: "",
    flat: "",
    area: "",
    landmark: "",
  });
};


 const handleSaveClick = () => {
  const updated = [...addresses];
  updated[editingIndex].address = `${editedAddress.flat}, ${editedAddress.area}, ${editedAddress.landmark}, ${editedAddress.pincode}`;
  setAddresses(updated);
  setEditingIndex(null);
};

  const handleCancelClick = () => {
    setEditingIndex(null);
    setEditedAddress("");
  };

  const handleAddAddress = () => {
  const { pincode, flat, area, landmark } = newAddress;
  if (!pincode || !flat || !area || !landmark) {
    alert("Please fill in all fields.");
    return;
  }

  const base = addresses[0] || { name: "", phone: "" };
  const fullAddress = `${flat}, ${area}, ${landmark}, ${pincode}`;

  const newEntry = {
    name: base.name,
    phone: base.phone,
    address: fullAddress,
  };

  setAddresses([...addresses, newEntry]);
  setNewAddress({ pincode: "", flat: "", area: "", landmark: "" });
  setShowAddForm(false);
};
const handleAddressDelivery = async () => {
  if (onAddressSelect && selectedIndex !== null) {
    const selected = addresses[selectedIndex];
    onAddressSelect(selected.address);

    try {
      await axios.post(`${baseURL}/saveVendorDeliveryAddresses`, {
        vendorId,
        addresses,
      });
      return true; // success
    } catch (error) {
      console.error("Error saving addresses:", error);
      return false; // failed
    }
  }
  return false; // no address selected
};



  return (
    <div className="delivery-container">

      <h3 className="delivery-title">Delivery addresses ({addresses.length})</h3>

      <div className="address-scroll-area">
        {addresses.map((item, index) => (
          <div
            className={`address-card ${selectedIndex === index ? "selected" : ""}`}
            key={index}
          >

            <input
  type="radio"
  name="address"
  checked={selectedIndex === index}
  onChange={() => handleSelectAddress(index)}
/>





            <div className="address-details">
              <p className="name">{item.name}</p>

              {editingIndex === index ? (
  <>
    <input
      type="text"
      placeholder="Pincode"
      value={editedAddress.pincode}
      onChange={(e) => setEditedAddress({ ...editedAddress, pincode: e.target.value })}
      maxLength={6}
      pattern="\d{6}"
    />
    <input
      type="text"
      placeholder="Flat, House no., Building"
      value={editedAddress.flat}
      onChange={(e) => setEditedAddress({ ...editedAddress, flat: e.target.value })}
    />
    <input
      type="text"
      placeholder="Area, Street, Sector, Village"
      value={editedAddress.area}
      onChange={(e) => setEditedAddress({ ...editedAddress, area: e.target.value })}
    />
    <input
      type="text"
      placeholder="Landmark"
      value={editedAddress.landmark}
      onChange={(e) => setEditedAddress({ ...editedAddress, landmark: e.target.value })}
    />
    <div className="edit-actions">
      <button onClick={handleSaveClick} className="edit-save">Save</button>
      <button onClick={handleCancelClick} className="edit-cancel">Cancel</button>
    </div>
  </>
) : (
                <>
                  <p>{item.address}</p>
                  <p>Phone number: {item.phone}</p>
                 {item.isSelected && <p className="selected-label">Selected for delivery</p>}
                  <div className="address-actions">
                    <a href="#" onClick={(e) => { e.preventDefault(); handleEditClick(index); }}>Edit address</a>
                  </div>
                </>
              )}
            </div>
          </div>
        ))}

        {showAddForm && (
  <div className="add-form">
    <input
      type="text"
      placeholder="Pincode"
      value={newAddress.pincode}
      onChange={(e) => setNewAddress({ ...newAddress, pincode: e.target.value })}
      maxLength={6}
      pattern="\d{6}"
    />
    <input
      type="text"
      placeholder="Flat, House no., Building"
      value={newAddress.flat}
      onChange={(e) => setNewAddress({ ...newAddress, flat: e.target.value })}
    />
    <input
      type="text"
      placeholder="Area, Street, Sector, Village"
      value={newAddress.area}
      onChange={(e) => setNewAddress({ ...newAddress, area: e.target.value })}
    />
    <input
      type="text"
      placeholder="Landmark"
      value={newAddress.landmark}
      onChange={(e) => setNewAddress({ ...newAddress, landmark: e.target.value })}
    />
    <div className="add-actions">
      <button onClick={handleAddAddress} className="edit-save">Add</button>
      <button onClick={() => setShowAddForm(false)} className="edit-cancel">Cancel</button>
    </div>
  </div>
)}


      </div>

      {!showAddForm && (
        <div className="add-address">
          <a href="#" onClick={(e) => { e.preventDefault(); setShowAddForm(true); }}>
            Add a new delivery address
          </a>
        </div>
      )}

<label
  className={`deliver-checkbox-button ${isDeliveryConfirmed ? 'selected' : ''}`}
  onClick={async () => {
    const success = await handleAddressDelivery();
    if (success) {
      setIsDeliveryConfirmed(!isDeliveryConfirmed);
    }
  }}
>
  <input
    type="checkbox"
    checked={isDeliveryConfirmed}
    readOnly
    style={{ display: 'none' }}
  />
  {isDeliveryConfirmed ? "✅ Delivering to this address" : "☐ Deliver to this address"}
</label>







    </div>
  );
};

export default DeliveryAddress;
